import React from 'react';
import { Box, Button } from '@material-ui/core';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { userColumn } from './columns';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import { getAllSchoolAsync } from './bccTeenybeansStore/bccTeenybeansStoreSlice';

function AllSchools() {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(1);
  const [userName, setUserName] = React.useState('');
  const [status, setStatus] = React.useState('');

  const { allSchool } = useSelector((state) => {
    const { teenybeansReducer } = state;
    return {
      allSchool: teenybeansReducer.allSchool,
    };
  });

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(
        getAllSchoolAsync({
          params: { page: 1, limitPerPage: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All School were fetched successfully!');
        });
    } catch (error) {
      toast.error('School could not be fetched. Please try again!');
    }
  };
  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getAllSchoolAsync({
          params: { page: val, limitPerPage: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All School were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };
  const handleSearchUser = () => {
    // var emailValidate = /\S+@\S+\.\S+/;
    // API call
    dispatch(
      getAllSchoolAsync({
        params: {
          searchText: userName,
        },
      })
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
    // API call
    dispatch(
      getAllSchoolAsync({
        params: { isActive: e.target.value },
      })
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <div>
      <Box display="flex">
        <Box sx={{ width: 350 }} mr={2} mb={2}>
          <BuzzInput
            size="small"
            placeholder="Search by school name"
            search
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            onSubmitEditing={handleSearchUser}
          />
        </Box>
        <Box mr={2} sx={{ width: 140 }}>
          <BuzzSelect
            labelKey="label"
            valueKey="value"
            options={[
              { label: 'Active', value: 'true' },
              { label: 'Inactive', value: 'false' },
            ]}
            placeholder="Status"
            value={status}
            onChange={handleStatus}
            size="small"
          />
        </Box>
        <Box ml={'auto'}>
          <Link to="/teenybeans-portal/add-school">
            <Button color="primary" size="large" variant="contained">
              Add a school
            </Button>
          </Link>
        </Box>
      </Box>
      <BuzzTable columns={userColumn} data={allSchool && allSchool.data} />
      <Box display="flex" justifyContent="center">
        <BuzzPagination
          onClick={handlePageChange}
          total={
            allSchool &&
            allSchool.count &&
            allSchool.count[0] &&
            allSchool.count[0].total
          }
          pageNo={page}
          defaultPage={1}
          perPage={10}
        />
      </Box>
    </div>
  );
}

export default AllSchools;
